import React from 'react';
import {
  Alert,
  Col,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';

import EmptyStateImage from './components/Image';

import { searchTerm } from '../../helpers/Terms';

const EmptySmartCollection = ({ collection }) => {
  const intl = useIntl();

  const hasBlockedFilters = collection && collection.attributes?.filters?.find(f => {
    const term = searchTerm(f.key);
    if (term?.blocked) return true;
    return false;
  });

  return (
    <div
      className="content-wrapper nothing-found-wrapper empty-state-wrapper row align-items-center justify-content-center"
    >
      <Col lg="5" xs="12">
        <h2>
          <span className="text-glow-violet mr-3">
            <i className="fas fa-bolt" />
          </span>
          {intl.formatMessage({ defaultMessage: 'This Smart Collection is empty!' })}
        </h2>
        <div className="mt-4">
          {intl.formatMessage({ defaultMessage: 'Smart Collections are created dynamically based on your selected filters. Add some files that match!' })}
        </div>
        {hasBlockedFilters && (
          <Alert color="warning" className="mt-4">
            {intl.formatMessage({ defaultMessage: 'Your Smart Filter could be using blocked tags, which is why you are not seeing results. Review your filters in the Smart Collection settings.' })}
          </Alert>
        )}
      </Col>
      <EmptyStateImage imageUrl="/images/empty-pages/empty-all-collections-page.png" height="high" />
    </div>
  );
};

const mapStateToProps = state => ({
  collection: state.Collections.collection,
});

EmptySmartCollection.propTypes = {
  collection: PropTypes.object,
};

EmptySmartCollection.defaultProps = {
  collection: null,
};

export default connect(mapStateToProps)(EmptySmartCollection);
